import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, unref as _unref, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bed6c00"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "move_home" }

import { onMounted } from 'vue'
import MoveDiv from '@/components/MoveDiv/index.vue'
import useRouter_Route from '@/hooks/useRouter_Route'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

const { toNextRoute } = useRouter_Route()

onMounted(() => {})

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(MoveDiv, null, {
      default: _withCtx(() => [
        _createElementVNode("div", {
          class: "home_icon",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(toNextRoute)('/home')))
        }, [
          _createVNode(_component_van_icon, {
            name: "wap-home-o",
            size: "28",
            color: "#3ED7A0"
          })
        ])
      ]),
      _: 1
    })
  ]))
}
}

})